const X = () => (
    <svg
        width="22"
        height="23"
        viewBox="0 0 22 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M16.4402 2H19.4861L12.8325 9.6239L20.6607 20H14.5321L9.72851 13.7082L4.23828 20H1.18957L8.30559 11.8427L0.799438 2.00142H7.08412L11.4196 7.75126L16.4402 2ZM15.3691 18.1728H17.0573L6.16199 3.73219H4.35177L15.3691 18.1728Z"
            fill="white"
        />
    </svg>
);

export default X;
